/**
 * API for SavedItems
 * @module api/savedItems
 */

import Settings from '../settings';

const API_VERSION = 'v1';

export const getFolders = userId =>
  fetch(`${Settings.camioApiUrl}${API_VERSION}/saveditems/folders?userId=${userId}`, {
    mode: 'cors'
  }).then(response => {
    if (response.ok) {
      return response.json();
    }
    return Promise.reject({ error: 'Error in getFolder' });
  });

export const createSavedItem = (mosObjectId, folderId, userId) => {
  const payload = {
    mosObjectId,
    folderId
  };

  if (userId) {
    payload.userId = userId;
  }

  return fetch(`${Settings.camioApiUrl}${API_VERSION}/saveditems/`, {
    mode: 'cors',
    method: 'post',
    dataType: 'json',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  }).then(response => {
    if (response.ok) {
      return response.json();
    }
    return Promise.reject({ error: 'Error while created saved item.' });
  });
};

export const addFolder = (name, parentId, owner, expirationHours) =>
  fetch(`${Settings.camioApiUrl}${API_VERSION}/saveditems/folders`, {
    mode: 'cors',
    method: 'post',
    dataType: 'json',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name,
      parentId,
      owner,
      expirationHours
    })
  }).then(response => {
    const json = response.json();
    if (response.ok) {
      return json;
    }
    return json.then(r => Promise.reject(r));
  });

export const updateFolder = (folderId, name, parentId, owner, expirationHours) =>
  fetch(`${Settings.camioApiUrl}${API_VERSION}/saveditems/folders/${folderId}`, {
    mode: 'cors',
    method: 'put',
    dataType: 'json',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name,
      parentId,
      owner,
      expirationHours
    })
  }).then(response => {
    if (response.ok) {
      return true;
    }
    return Promise.reject(false);
  });

export const removeFolder = folderId =>
  fetch(`${Settings.camioApiUrl}${API_VERSION}/saveditems/folders/${folderId}`, {
    mode: 'cors',
    method: 'delete'
  }).then(response => {
    if (response.ok) {
      return '';
    }
    return response.json().then(r => Promise.reject(r));
  });

export const deleteSavedItem = id =>
  fetch(`${Settings.camioApiUrl}${API_VERSION}/saveditems/${id}`, {
    mode: 'cors',
    method: 'delete'
  }).then(response => {
    if (response.ok) {
      return '';
    }
    return response.json().then(r => Promise.reject(r));
  });



// WEBPACK FOOTER //
// ./app/api/savedItems.js